import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import TripleLogo from './TripleLogo'
// import HomeVideo from './HomeVideo'

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content" id="welcome">
            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
              Welcome to <span className="text-color-primary">AVstack</span>
            </h1>
            <div className="container-xs">
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                An open-source, reconfigurable software solution for autonomous vehicle design, implementation, test, and analysis.
              </p>
            </div>
            <TripleLogo/>
          </div>
          <div className="container-xs">
              <p className="h3 m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                <a href={"https://avstack.readthedocs.io"} rel="noopener noreferrer" target="_blank">Visit our <span className="text-color-primary">ReadTheDocs</span> </a>
              </p>
              <p className="h3 mb-32 reveal-from-bottom" data-reveal-delay="400">
                <a href={"https://github.com/avstack-lab"} rel="noopener noreferrer" target="_blank">Visit our <span className="text-color-primary">GitHub</span></a>
              </p>
            </div>
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;